import { Tooltip } from '@monorepo/controlled/src/components/tooltip/tooltip/tooltip';
import styles from './overflow-column.module.scss';

interface IOverflowColumn {
	data: string;
	maxWidth?: string;
}

export const OverflowColumn = (props: IOverflowColumn) => {
	const { data, maxWidth } = props;
	return (
		<Tooltip content={data}>
			<div className={styles.overflowColumn} style={{ maxWidth }}>
				{data}
			</div>
		</Tooltip>
	);
};
